export default "__VITE_ASSET__CnZEjEX0__"